import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { distinctUntilChanged, filter, map, Observable, startWith } from "rxjs";

import { AgentService } from "src/app/services/agent.service";

import { AgentCompany } from "src/app/models/agent";


@Component({
    selector: 'mwp-companies-dropdown',
    templateUrl: './companies.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompaniesDropdownComponent implements OnInit {
    @Input() public form: FormGroup;
    @Input() public nameForControl: string;
    @Input() public idForControl: string;

    @Output() public emitSelectedCompany: EventEmitter<AgentCompany> = new EventEmitter();

    public enabledCompanies: AgentCompany[];
    public filteredCompanies$: Observable<AgentCompany[]>;

    constructor(
        private agentService: AgentService,
    ) {
    }

    ngOnInit(): void {
        this.agentService.getAgentEnabledCompanies().subscribe((response: AgentCompany[]) => {
            this.enabledCompanies = response;

            this.filteredCompanies$ = this.form.get(this.nameForControl).valueChanges.pipe(
                startWith(''),
                filter(value => typeof value === 'string'),
                distinctUntilChanged(),
                map(searchTerm => this.filterCompany(searchTerm)),
            );
        });
    }

    private filterCompany(searchTerm: string): AgentCompany[] {
        if (!searchTerm)
            return this.enabledCompanies;

        return this.enabledCompanies.filter(company => company.companyName.toLowerCase().startsWith(searchTerm.toLowerCase()));
    }

    public onSelectionChanged(event: MatAutocompleteSelectedEvent): void {
        if (event.option.value) {
            this.form.get(this.nameForControl).setValue(event.option.value.companyName);
            this.form.get(this.idForControl).setValue(event.option.value.companyID);

            this.emitSelectedCompany.emit(event.option.value);
        }
    }
}